type TillsKeysListArgs = {
  filters?: {
    assigned?: boolean;
  };
};

export const tillsKeys = {
  all: ["tills"] as const,
  lists: () => [...tillsKeys.all, "list"] as const,
  list: ({ filters }: TillsKeysListArgs) =>
    filters ? ([...tillsKeys.lists(), filters] as const) : tillsKeys.lists(),
  details: () => [...tillsKeys.all, "detail"] as const,
  detail: (id: string) => [...tillsKeys.details(), id] as const
};
